// src/hooks/termOfPayments/useRestoreTermOfPayment.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreTermOfPayment } from "../../api/apiTermOfPayments";
import parseError from "../../utils/parseError";

const useRestoreTermOfPayment = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreTermOfPayments, isPending } = useMutation({
        mutationFn: restoreTermOfPayment,
        onSuccess: (res) => {
            const message = res?.message || "Term of payment restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore term of payment");
        },
    });

    return { restoreTermOfPayments, isPending };
};

export default useRestoreTermOfPayment;